<template>
    <div>
        <div class="space-y-4 text-sm">
            <div
                class="grid grid-cols-10 gap-2 lg:gap-4 space-y-4 lg:space-y-0"
            >
                <div class="col-span-10 lg:col-span-2">
                    <MeetingDetailsBlock
                        iconName="clock"
                        title="Timeslot"
                    >
                        <div>
                            {{ meetingData.meeting.startAtFormatted }} -
                            {{ meetingData.meeting.endAtFormatted }}
                        </div>
                        <div class="text-gray-600">
                            {{ meetingData.meeting.duration }} mins
                        </div>
                        <div class="text-xs text-gray-600">
                            {{ displayTimezone }}
                        </div>
                    </MeetingDetailsBlock>
                </div>
                <div class="col-span-10 lg:col-span-2">
                    <MeetingDetailsBlockService
                        :service="meetingData.service"
                    />
                </div>
                <div class="col-span-10 lg:col-span-2">
                    <MeetingDetailsBlockMeetingLink
                        title="Location"
                        :meeting="meetingData.meeting"
                    />
                </div>
                <div class="col-span-10 lg:col-span-2">
                    <MeetingDetailsBlockHost :host="meetingData.user" />
                </div>
                <div
                    v-if="meetingData.hasSingleReservation()"
                    class="col-span-10 lg:col-span-2"
                >
                    <MeetingDetailsBlockCustomer
                        :customer="
                            meetingData.getSingleExistingReservationData()
                                .customer
                        "
                    />
                </div>
            </div>
            <div
                v-if="
                    meetingData.hasSingleReservationWithNotes() &&
                    !isCardExpanded
                "
            >
                <MeetingDetailsBlockNotes
                    :notes="
                        meetingData.getSingleExistingReservationData()
                            .reservation.notes ?? ''
                    "
                />
            </div>
        </div>

        <CardExpandSection :isCardExpanded="isCardExpanded" />
    </div>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'
    import MeetingData from '@/App/Booking/Meeting/Entity/MeetingData'
    import MeetingDetailsBlock from '@/App/Booking/Meeting/Component/MeetingDetailsBlock.vue'
    import CardExpandSection from '@/App/Booking/Meeting/Component/CardExpandSection.vue'
    import MeetingDetailsBlockService from '@/App/Booking/Meeting/Component/MeetingDetailsBlockService.vue'
    import MeetingDetailsBlockHost from '@/App/Booking/Meeting/Component/MeetingDetailsBlockHost.vue'
    import MeetingDetailsBlockCustomer from '@/App/Booking/Meeting/Component/MeetingDetailsBlockCustomer.vue'
    import MeetingDetailsBlockMeetingLink from '@/App/Booking/Meeting/Component/MeetingDetailsBlockMeetingLink.vue'
    import MeetingDetailsBlockNotes from '@/App/Booking/Meeting/Component/MeetingDetailsBlockNotes.vue'
    import type { TimeZoneEnum } from '@/Shared/AutoGenerated/TimeZoneEnum'

    const props = defineProps({
        meetingData: {
            type: Object as PropType<MeetingData>,
            required: true,
        },
        isCardExpanded: {
            type: Boolean,
            required: true,
        },
        displayTimezone: {
            type: String as PropType<TimeZoneEnum>,
            required: true,
        },
    })
</script>
